import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateLandingPage as CreateLandingPageMutation,
    CreateLandingPageVariables as CreateLandingPageMutationVariables,
    DuplicateLandingPage as DuplicateLandingPageMutation,
    DuplicateLandingPageVariables as DuplicateLandingPageMutationVariables,
} from 'nutshell-graphql-types';

import {START_FROM_SCRATCH_ID} from '../../create-page/create-page-modal-root';

import CREATE_LANDING_PAGE from '../mutations/create-landing-page.graphql';
import DUPLICATE_LANDING_PAGE from '../mutations/duplicate-landing-page.graphql';

export function useCreateLandingPage(): {
    createLandingPage: (name: string, publicSlug: string, pageStarterId?: string) => Promise<any>;
    isCreating: boolean;
    error: string | null | undefined;
    duplicateSlugError: boolean;
    unsafeUrlError: boolean;
} {
    const [createLandingPage, {loading: isCreating, error: errorCreating}] = useMutation<
        CreateLandingPageMutation,
        CreateLandingPageMutationVariables
    >(CREATE_LANDING_PAGE);

    const [duplicateLandingPage, {loading: isDuplicating, error: errorDuplicating}] = useMutation<
        DuplicateLandingPageMutation,
        DuplicateLandingPageMutationVariables
    >(DUPLICATE_LANDING_PAGE);

    // @ts-expect-error
    const errorMessage = safelyGetGraphQLErrorMessage(errorCreating || errorDuplicating);

    return {
        createLandingPage: (name: string, publicSlug: string, pageStarterId?: string) =>
            pageStarterId && pageStarterId !== START_FROM_SCRATCH_ID
                ? duplicateLandingPage({
                      variables: {input: {name, publicSlug, pageId: pageStarterId}},
                  }).then(
                      (result) =>
                          result &&
                          result.data &&
                          result.data.pageDuplicate &&
                          result.data.pageDuplicate.page &&
                          result.data.pageDuplicate.page.htmlUrlPath
                  )
                : createLandingPage({
                      variables: {input: {name, publicSlug}},
                  }).then(
                      (result) =>
                          result &&
                          result.data &&
                          result.data.pageCreate &&
                          result.data.pageCreate.page &&
                          result.data.pageCreate.page.htmlUrlPath
                  ),
        isCreating: isCreating || isDuplicating,
        error: errorMessage,
        duplicateSlugError: Boolean(errorMessage && errorMessage.includes('Duplicate entry')),
        unsafeUrlError: Boolean(errorMessage && errorMessage.includes('unsafe characters')),
    };
}
